export const encryptionKeys = {
  IV: '7g5y6fdlctdegihj',
  key: '5pa7nohechag5j2'
};
export interface keyValuePair {
  key: string;
  value:number;
}

export const userRole = {
  Admin: 1,
  SubAdmin: 2
};

export const bannerRole = {
  admin: 1,
  partner: 2
};

export const restaurantStatus = {
  pending: 0,
  accepted:1,
  rejected:2,
  onboarded: 3
};


export const docStatus = {
  pending: 0,
  accepted:1,
  rejected:2
};
export interface keyValuePair {
  key: string;
  value:number;
}


export const docStatuses : Array<keyValuePair> = [
  {
    key: 'pending',
    value: docStatus.pending
  },
  {
    key: 'accepted',
    value: docStatus.accepted
  },
  {
    key: 'rejected',
    value: docStatus.rejected
  }
];

export const dealStatus = {
  accepted:1
};

export const PackageStatus = {
  pending: 0,
  accepted: 1,
  rejected: 2
};

export const dealStatuses : Array<keyValuePair> = [
  {
    key: 'accepted',
    value: dealStatus.accepted
  }
];

export const packageStatuses : Array<keyValuePair> = [
  {
    key: 'pending',
    value: PackageStatus.pending
  },
  {
    key: 'accepted',
    value: PackageStatus.accepted
  },
  {
    key: 'rejected',
    value: PackageStatus.rejected
  }
];

export const filterStatus = {
  expired: 3,
  refunded:4
};

export const filterStatuses : Array<keyValuePair> = [
  {
    key: 'expired',
    value: filterStatus.expired
  },
  {
    key: 'refunded',
    value: filterStatus.refunded
  }
];

export const bookingStatusTabs = {
  Pending: 0,
  Completed: 1,
  Reedemed: 2,
  Cancelled: 3,
  Declined: 4
};

export const bookingStatusTabsOther = {
  Pending: 0,
  Completed: 1,
  Reedemed: 2,
  Cancelled: 3,
  Declined: 4
};

export const PackageBookingConst = {
  Normal: 0,
  Daily: 1,
  Slots: 2,
  Hourly: 3,
  Admin: 4,
  Custom: 5,
  Monthly: 6
};

export const PACKAGE_BOOKING_TYPE_CONST: Array<keyValuePair> = [
  {
    key: 'Normal',
    value: PackageBookingConst.Normal
  },
  {
    key: 'Daily',
    value: PackageBookingConst.Daily
  },
  {
    key: 'Slots',
    value: PackageBookingConst.Slots
  },
  {
    key: 'Hourly',
    value: PackageBookingConst.Hourly
  },
  {
    key: 'Monthly',
    value: PackageBookingConst.Monthly
  }
];

export const statusTabs = {
  Pending: 0,
  Accepted: 1,
  Ongoing: 2,
  Expired: 3
};

export const statusConst = [
  {
    key: 'Accepted',
    value: 1
  },
  {
    key: 'Rejected',
    value: 2
  }
];

export const StatusConst = {
  PENDING: 0,
  ACCEPTED: 1,
  ONGOING: 2,
  EXPIRED: 3
};

export const partnerStatus = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2
};

export const packageStatus = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2
};


export const PackageTimeConst = {
  FifteenMinutes: 15,
  ThirtyMinutes: 30,
  FortyFiveMinutes: 45,
  SixtyMinutes: 60,
  OneTwentyMinutes: 120,
  TwoFortyMinutes: 240,
  FourEightyMinutes: 480
};

export const PACKAGE_TIME_OPTIONS: Array<keyValuePair> = [
  {
    key: '15 min',
    value: PackageTimeConst.FifteenMinutes
  },
  {
    key: '30 min',
    value: PackageTimeConst.ThirtyMinutes
  },
  {
    key: '45 min',
    value: PackageTimeConst.FortyFiveMinutes
  },
  {
    key: '1 hour',
    value: PackageTimeConst.SixtyMinutes
  },
  {
    key: '2 hours',
    value: PackageTimeConst.OneTwentyMinutes
  },
  {
    key: '4 hours',
    value: PackageTimeConst.TwoFortyMinutes
  },
  {
    key: '8 hours',
    value: PackageTimeConst.FourEightyMinutes
  }
];

export const WEEK_DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export interface SlotData {
  dayNumber: number;
  isAvailable: boolean;
  slotEndTime: string;
  slotStartTime: string;
}

// Initial Slot Data (if any)
export const INITIAL_SLOT_DATA: SlotData[] = [];

